import React from 'react'

interface DocFooterProps {
  names: {
    profileName: string
    organizationName: string
    clientName: string
  }
}

const DocFooter: React.FC<DocFooterProps> = ({ names }) => {
  return (
    <div className="flex flex-row justify-between w-full mt-20 print:mt-12 mb-12 print:mb-8 px-8 print:px-4 print:break-inside-avoid">
      {/* Seller Signature Column */}
      <div className="w-5/12 text-center">
        <hr className="border-t-2 print:border-t border-gray-900 w-full mb-4 print:mb-2" />
        <div className="text-base print:text-sm">
          <p className="font-bold uppercase">{names.profileName}</p>
          <p className="text-gray-700 text-sm print:text-xs mt-2 print:mt-1">{names.organizationName}</p>
          <p className="text-sm print:text-xs text-gray-500 mt-4 print:mt-2 italic uppercase">Firma Vendedor</p>
        </div>
      </div>

      {/* Client Signature Column */}
      <div className="w-5/12 text-center">
        <hr className="border-t-2 print:border-t border-gray-900 w-full mb-4 print:mb-2" />
        <div className="text-base print:text-sm">
          <p className="font-bold uppercase">{names.clientName}</p>
          <p className="text-sm print:text-xs text-gray-500 mt-4 print:mt-2 italic uppercase">Firma Cliente</p>
        </div>
      </div>
    </div>
  )
}

export default DocFooter
